// 動的インポート（lazy load）で解決に失敗したエラーのメッセージ断片。
// 新しいデプロイ後に古い chunk が参照できない／ネットワーク瞬断で発生する。
const DYNAMIC_IMPORT_ERROR_FRAGMENTS = [
  "Couldn't resolve component",
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
];

export function isDynamicImportError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return DYNAMIC_IMPORT_ERROR_FRAGMENTS.some(fragment =>
    message.includes(fragment),
  );
}
